import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { getData, putData } from "../../../utils/api";
import {
  ExpertOrderType,
  IDS,
  OrderAssignType,
  OrderExpertStatus,
  RoleId,
  Select2Data,
} from "../../../utils/common";
import { logDOM } from "@testing-library/react";
import Spinner from "react-bootstrap/Spinner";
library.add(fas);

const VendorAssign = (props) => {
  const { postData, user } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [data, setData] = useState({});
  const GetOneDetails = async (id) => {
    try {
      const response = await getData(`/admin/orders/order/${id}`);

      if (response?.success) {
        setData(response?.data);
      } else {
        console.error("API failed:", response?.message);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };

  useEffect(() => {
    GetOneDetails(props.show);
  }, [props.show]);

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      assignments: [
        {
          expert_id: null,
          pickup_area_id: null,
        },
      ],
    },
  });

  const [loader, setLoader] = useState(false);
  const onSubmit = async (d) => {
    try {
      setLoader(true);
      const finalData = new FormData();
      finalData.append("vendor_id", d?.vendor_id?.value);
      const response = await postData(
        `/admin/orders/assign/vendor/${props?.show}`,
        finalData,
      );

      if (response?.success) {
        setLoader(false);
        props.GetAllCounts();
        await setShowModal({ code: response.code, message: response.message });
      } else {
        setLoader(false);
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const Select3Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      name: name,
      data: data,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const [vendor, setVendor] = useState([]);
  const GetAllVendor = async () => {
    const response = await getData(
      `/common/masters/all-design-vendors/${data?.Design?.id}?vendor_id=${data?.vendor_id}`,
    );
    if (response?.success) {
      setVendor(await Select3Data(response?.data, "vendor_id"));
    }
  };
  useEffect(() => {
    GetAllVendor();
  }, [data]);
  const vendorData = watch("vendor_id");
 
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Assign Vendor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Row className="row justify-content-center mb-2">
                  <Form.Label>Vendor</Form.Label>
                  <Controller
                    name="vendor_id" // name of the field
                    {...register("vendor_id", {
                      required: "Select Vendor",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.vendor_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={vendor}
                      />
                    )}
                  />
                  {errors.vendor_id && (
                    <span className="text-danger">
                      {errors.vendor_id.message}
                    </span>
                  )}
                </Row>
              </div>
            </Col>

            <div className="section-heading">Order Details</div>
            <div className="order-box">
              <span>
                <strong>Order Price : </strong>{" "}
                {Number(data?.total_amount).toFixed(2)}{" "}
              </span>
              <br></br>
              {vendorData?.data?.Vender_Design_Rates?.length > 0 && (
                <span>
                  <strong> New Vendor Price : </strong>{" "}
                  {Number(
                    vendorData?.data?.Vender_Design_Rates[0]?.price,
                  ).toFixed(2)}
                </span>
              )}
            </div>

            {loader ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <SaveButton name="Assign" handleSubmit={handleSubmit(onSubmit)} />
            )}
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default VendorAssign;
